<template>
    <div class="line-text-wrap">
        <div class="line"></div>
        <p>{{text}}</p>
        <div class="line"></div>
    </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '测试'
    }
  }
}
</script>

<style lang="scss" scoped>
.line-text-wrap {
    display: flex;
    height: 60px;
    width: 100%;
    justify-content: center;
    align-items: center;
    p {
        margin: 0 26px;
        font-size: 30px;
        color: #0052bc;
        font-weight: bold;
        line-height: 38px;
    }
    .line {
        width: 90px;
        border-bottom: 1px solid #0052bc;
    }
}
</style>
